export default __webpack_public_path__ + "static/media/strategy2.da2d9b10.png";